/* svg-icon.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./svg-icon.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  iconContainerStyles: "_1e0c1txw _4cvr1h6o _1bah1h6o",
  iconContainerStylesSmall: "_1bsb7vkz _4t3i7vkz",
  iconContainerStylesMedium: "_1bsb1tcg _4t3i1tcg",
  iconContainerStylesLarge: "_1bsbzwfg _4t3izwfg",
  iconContainerStylesXlarge: "_1bsbzwfg _4t3izwfg"
};
export function SVGIcon(_ref) {
  var SVG = _ref.glyph,
    label = _ref.label,
    size = _ref.size,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.iconContainerStyles, size === 'small' && styles.iconContainerStylesSmall, size === 'medium' && styles.iconContainerStylesMedium, size === 'large' && styles.iconContainerStylesLarge, size === 'xlarge' && styles.iconContainerStylesXlarge),
    "aria-label": label,
    testId: testId
  }, /*#__PURE__*/React.createElement(SVG, null));
}